<template>
  <!--页面加载动画-->
  <div>
    <template v-for="item in fromData">
      <!-- 选择 -->
      <div class="items" v-if="(item.elementType==1 || item.elementType==2) && item.show" :name="item.elementCode" :data-path="item.elementPath">
        <div class="items-wrap">
          <span class="lables">
            {{item.elementName}}
             <i class="iconfont iconyiwenhao informLayer" v-if="item.elementLayer" @click="showAlert(item.elementLayer)"></i>
          </span>
          <div class="from-right">
            <app-select :selectData="item" :parentItem="parentItem" @selected="selectedBack"></app-select>
          </div>
        </div>
        <span v-show="item.errorMsg" class="errorMsg">{{item.errorMsg}}</span>
        <p v-if="item.elementDescribe" class="notes">{{item.elementDescribe}}</p>
      </div>
      <!-- 输入框-文本 -->
      <div class="items" v-if="item.elementType==3 && item.show" :name="item.elementCode" :data-path="item.elementPath">
        <div class="items-wrap">
          <span class="lables">{{item.elementName}}</span>
          <div class="from-right">
            <app-inputs :selectData="item" :parentItem="parentItem" type="1" @selected="selectedBack"></app-inputs>
          </div>
        </div>
        <span v-show="item.errorMsg" class="errorMsg">{{item.errorMsg}}</span>
      </div>
      <!-- 时间选择 -->
      <div class="items" v-if="item.elementType==4 && item.show" :name="item.elementCode" :data-path="item.elementPath">
        <div class="items-wrap">
          <span class="lables">
            {{item.elementName}}

          </span>
          <div class="from-right">
            <app-time :selectData="item" @selected="selectedBack"></app-time>
          </div>
        </div>
        <span v-show="item.errorMsg" class="errorMsg">{{item.errorMsg}}</span>
        <p v-if="item.elementDescribe" class="notes">{{item.elementDescribe}}</p>
      </div>
      <!-- 默认文本展示 -->
      <div class="items form-no-check" v-if="item.elementType==5 && item.show" :name="item.elementCode" :data-path="item.elementPath">
        <div class="items-wrap">
          <span class="lables">
            {{item.elementName}}
          </span>
          <div class="from-right">
            <span class="in-text">{{item.elementValue}}</span>
          </div>
        </div>
        <p v-if="item.elementDescribe" class="notes">{{item.elementDescribe}}</p>
      </div>
      <!-- 地区选择 -->
      <div class="items" v-if="item.elementType==6 && item.show" :name="item.elementCode" :data-path="item.elementPath">
        <div class="items-wrap">
          <span class="lables">
            {{item.elementName}}
          </span>
          <div class="from-right">
            <app-city :selectData="item" @selected="selectedBack"></app-city>
          </div>
        </div>
        <span v-show="item.errorMsg" class="errorMsg">{{item.errorMsg}}</span>
        <p v-if="item.elementDescribe" class="notes">{{item.elementDescribe}}</p>
      </div>
      <!-- 职业选择 -->
      <div class="items" v-if="item.elementType==8 && item.show" :name="item.elementCode" :data-path="item.elementPath">
        <div class="items-wrap">
          <span class="lables">
            {{item.elementName}}
          </span>
          <div class="from-right">
            <app-occupation :selectData="item" @selected="selectedBack"></app-occupation>
          </div>
        </div>
        <span v-show="item.errorMsg" class="errorMsg">{{item.errorMsg}}</span>
        <p v-if="item.elementDescribe" class="notes">{{item.elementDescribe}}</p>
      </div>
      <!-- 输入-数字 -->
      <div class="items" v-if="item.elementType==9 && item.show" :name="item.elementCode" :data-path="item.elementPath">
        <div class="items-wrap">
          <span class="lables">
            {{item.elementName}}
            <p v-if="item.elementTips" class="notes">{{item.elementTips}}</p>
          </span>
          <div class="from-right">
            <app-inputs :selectData="item" :parentItem="parentItem" type="2" @selected="selectedBack"></app-inputs>
          </div>
        </div>
        <span v-show="item.errorMsg" class="errorMsg">{{item.errorMsg}}</span>
      </div>
      <!-- 输入-电话号 -->
      <div class="items" v-if="item.elementType==10 && item.show" :name="item.elementCode" :data-path="item.elementPath">
        <div class="items-wrap">
          <span class="lables">{{item.elementName}}</span>
          <div class="from-right">
            <app-inputs :selectData="item" :parentItem="parentItem" type="3" @selected="selectedBack"></app-inputs>
          </div>
        </div>
        <span v-show="item.errorMsg" class="errorMsg">{{item.errorMsg}}</span>
      </div>
      <!-- 图片上传 -->
      <app-imgUpload  v-if="item.elementType==11 && item.show" :selectData="item" @selected="selectedBack"></app-imgUpload>
      <!-- 邮箱 -->
      <div class="items" v-if="item.elementType==14 && item.show" :name="item.elementCode" :data-path="item.elementPath">
        <div class="items-wrap">
          <span class="lables">{{item.elementName}}</span>
          <div class="from-right">
            <app-email :selectData="item" @selected="selectedBack"></app-email>
          </div>
        </div>
        <span v-show="item.errorMsg" class="errorMsg">{{item.errorMsg}}</span>
      </div>
      <!-- 图片上传 -->
      <img-ocr :selectData="item" @selected="selectedBack" v-if="item.elementType==18 && item.show"></img-ocr>
      <!-- 字母选择器 -->
      <div class="items" v-if="item.elementType==15 && item.show" :name="item.elementCode" :data-path="item.elementPath">
        <div class="items-wrap">
          <span class="lables">
            {{item.elementName}}
            <p v-if="item.elementDescribe" class="notes">{{item.elementDescribe}}</p>
          </span>
          <div class="from-right">
            <app-letter :selectData="item" @selected="selectedBack"></app-letter>
          </div>
        </div>
        <span v-show="item.errorMsg" class="errorMsg">{{item.errorMsg}}</span>
      </div>
      <!-- 多选选择 -->
      <div class="items" v-if="item.elementType==19 && item.show" :name="item.elementCode" :data-path="item.elementPath">
        <div class="items-wrap">
          <span class="lables">
            {{item.elementName}}
             <i class="iconfont iconyiwenhao informLayer" v-if="item.elementLayer" @click="showAlert(item.elementLayer)"></i>
          </span>
          <div class="from-right">
            <app-multiple-choice :selectData="item" :parentItem="parentItem" @selected="selectedBack"></app-multiple-choice>
          </div>
        </div>
        <p v-if="item.elementDescribe" class="notes">{{item.elementDescribe}}</p>
      </div>
      <!-- 银行卡号输入和校验 -->
      <div class="items" v-if="item.elementType==24 && item.show" :name="item.elementCode" :data-path="item.elementPath">
        <app-bank :selectData="item" @selected="selectedBack"></app-bank>
      </div>
      <!-- 默认文本展示-带数据 -->
      <div class="items form-no-check" v-if="item.elementType==25 && item.show" :name="item.elementCode" :data-path="item.elementPath">
        <div class="items-wrap">
          <span class="lables">
            {{item.elementName}}
            <i class="iconfont iconyiwenhao informLayer" v-if="item.elementLayer" @click="showAlert(item.elementLayer)"></i>
          </span>
          <div class="from-right">
            <span class="in-text">{{item.elementDescribe}}</span>
          </div>
        </div>
      </div>
      <premiumBtns v-if="item.elementType==27" :selectData="item" @selected="selectedBack"></premiumBtns>
      <app-verification v-if="item.elementType==28" :selectData="item" @selected="selectedBack"></app-verification>
      <!-- 计步器 -->
      <div class="items" v-if="item.elementType==29 && item.show" :name="item.elementCode" :data-path="item.elementPath">
        <div class="items-wrap">
          <span class="lables">
            {{item.elementName}}
          </span>
          <div class="from-right">
            <app-stepper :selectData="item" @selected="selectedBack"></app-stepper>
          </div>
        </div>
        <p v-if="item.elementDescribe" class="notes">{{item.elementDescribe}}</p>
      </div>
      <app-timeValidity v-if="item.elementType==30 && item.show" :selectData="item" @selected="selectedBack" :data-path="item.elementPath"></app-timeValidity>
      <!-- 文件上传 -->
      <app-t-fileUpload :selectData="item" @selected="selectedBack" v-if="item.elementType==31 && item.show" :data-path="item.elementPath"></app-t-fileUpload>
      <app-veriIdentity v-if="item.elementType==32" :selectData="item" @selected="selectedBack" :data-path="item.elementPath"></app-veriIdentity>
      <app-switch v-if="item.elementType==33" :selectData="item" @selected="selectedBack" :data-path="item.elementPath"></app-switch>

      <div class="items" v-if="item.elementType==37 && item.show" :name="item.elementCode" :data-path="item.elementPath">
        <div class="items-wrap">
          <span class="lables">
            {{item.elementName}}
          </span>
          <div class="from-right">
            <app-ageSelect :selectData="item" :parentItem="parentItem" @selected="selectedBack"></app-ageSelect>
          </div>
        </div>
        <span v-show="item.errorMsg" class="errorMsg">{{item.errorMsg}}</span>
        <p v-if="item.elementDescribe" class="notes">{{item.elementDescribe}}</p>
      </div>
      <!-- 外链跳转 -->
      <div class="items healthy-link" v-if="item.elementType==38 && item.show" :name="item.elementCode" :data-path="item.elementPath">
        <div class="items-wrap">
           <div class="healthy-link-left">{{item.elementName}}</div>
            <a class="healthy-link-right" :href="item.elementLink">
              <span>{{item.elementValue||'请阅读'}}</span>
              <i class="iconfont iconxiangyou"></i>
            </a>
        </div>
      </div>

      <!-- 描述文案 -->
      <div class="items itemDescInfo" v-if="item.elementType==40 && item.show" :name="item.elementCode" :data-path="item.elementPath">
        <div class="items-wrap">
          <div class="descInfo" v-html='item.elementDescribe'></div>
        </div>
      </div>

      <!-- readio 勾选 -->
      <app-readio :selectData="item" @selected="selectedBack" v-if="item.elementType==41 && item.show"></app-readio>
      <!-- 图片展示 -->
      <app-img-show :selectData="item" v-if="item.elementType==42 && item.show"></app-img-show>

      <!-- 电子签名 -->
      <app-signature :selectData="item" @selected="selectedBack" v-if="item.elementType==43 && item.show"></app-signature>
    </template>
  </div>
</template>

<script>
import selects from "./selects"; //选择器
import time from "./time"; //时间
import ageSelect from "./ageSelect"; //年龄选择
import citys from "./citys"; //城市
import bank from "./bank"; //银行卡号
import imgUpload from "./img"; //图片上传
import img_ocr from "./img_ocr"; //图片上传
import occupation from "./occupation"; //职业
import verification from "./verification"; //手机号和验证码-银行卡签约验证
import veriIdentity from "./veriIdentity"; //手机号和验证码
import email from "./email"; //职业
import inputs from "./inputs"; //输入框
import readio from "./readio"; //勾选框
import letter from "./letter"; //字母选择器
import stepper from "./stepper"; //计步器
import timeValidity from "./timeValidity"; //证件有效期
import premiumBtns from "./premiumBtns"; //测算按钮
import t_fileUpload from "./t_fileUpload"; //测算按钮
import _switch from "./switch"; //开关
import multiple_choice from "./multiple-choice"; //多选
import imgshow from './imgshow';//图片展示
import signature from './signature';//电子签名
export default {
  data() {
    return {};
  },
  components: {
    "app-select": selects, //单选
    "app-time": time, //时间选择
    "app-city": citys, //地区选择
    "app-occupation": occupation, //职业选择
    "app-verification": verification, //手机号和验证码-银行卡签约验证
    "app-veriIdentity": veriIdentity, //手机号和验证码
    "app-bank": bank, //银行卡号
    "app-imgUpload": imgUpload, //图片上传
    "img-ocr": img_ocr, //图片上传-ocr
    "app-email": email, //邮箱
    "app-inputs": inputs, //输入框
    "app-readio": readio, //勾选框
    "app-letter": letter, //字母选择器
    "app-stepper": stepper, //计步器
    "app-timeValidity": timeValidity, //证件有效期
    "premiumBtns": premiumBtns, //测算按钮
    "app-switch": _switch, //开关
    "app-ageSelect": ageSelect, //年龄选择
    "app-t-fileUpload": t_fileUpload, //excel文件上传
    "app-multiple-choice": multiple_choice, //多选
    "app-img-show":imgshow,//图片展示
    "app-signature":signature,//电子签名
  },
  props: ["fromData","parentItem"],
  mounted() {
    console.log(this.fromData);

  },
  methods: {
    selectedBack(data) {
      //选择后回调
      this.$emit("formChange", data);
    },
    // 展示弹窗
    showAlert(c){
      this.$notice.alert(c)
    }
  }
};
</script>

<style lang="scss">
.iconfabiaowenzhang {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: 36px;
  color: #0084ff;
}
.informLayer{
  color: #0084ff;
  font-size: 28px;
  cursor: pointer;
}
.healthy-link{
  overflow: hidden;
  &-right{
    &>span{
      display:inline-block;
      vertical-align: middle;
      color: #333;
    }
    &>i{
      display: inline-block;
      vertical-align: middle;
      color: #c8c8cd;
    }
  }
}
</style>
